module.exports = __webpack_public_path__ + "static/media/IMG_1293.add3a525.jpg";